// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`
#include <fog_pars_vertex>

uniform vec2 uFrequency;
uniform float uTime;
uniform float uWind;
uniform float uYOffset;
uniform sampler2D uMapId;

varying vec2 vUv;
varying float vElevation;
varying float vY;

void main()
{
    #include <begin_vertex>
    #include <project_vertex>
    #include <fog_vertex>
    // #include <fog_vertex>

     float f = uWind * 0.5;
     vec4 modelPosition = modelMatrix * vec4(position, 1.0);
     vec4 color = texture2D(uMapId, uv);

    float elevation = sin(color.x * uFrequency.x  - uTime* f) * 0.025;
     elevation += sin(color.y * uFrequency.y  - uTime* f * 0.3) * 0.025;

    modelPosition.y -= elevation* color.y;
    modelPosition.z += elevation* color.z;

    vec4 viewPosition = viewMatrix *  modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

    gl_Position = projectedPosition;

    vUv = uv;
    vY = modelPosition.y + uYOffset;
}`
